<script lang="ts" setup>
const { awesome } = useAppConfig()
const { t } = useI18n()
const { trackEvent } = useCnzz()

const trackEventFooter = (key: string) => {
  trackEvent('footer', '点击', t(key))
}
</script>

<template>
  <footer class="bg-white py-12 px-8">
    <div class="max-w-[1200px] mx-auto">
      <!-- 桌面端布局 -->
      <div class="hidden md:block">
        <!-- 主要内容区域 -->
        <div class="flex justify-between items-start mb-8 gap-[60px]">
          <!-- 左侧：Logo 和标语 -->
          <div class="flex flex-col gap-[76px]">
            <div class="flex items-center mb-4">
              <img
                src="@/assets/images/logo.png"
                alt="玻色量子"
                class="h-8 mr-2"
              />
            </div>
            <div
              class="text-gray-700 text-[30px] font-medium whitespace-pre-line"
            >
              {{ t('footer.webSlogan') }}<br />{{ t('footer.webSubSlogan') }}
            </div>
          </div>

          <!-- 中间：导航链接 -->
          <!-- <div class="flex space-x-32"> -->
          <!-- 第一列 -->
          <div class="flex flex-col space-y-[55px]">
            <NuxtLink
              :to="`/about`"
              class="text-[#333333] text-[20px] font-medium hover:text-gray-900"
              @click="trackEventFooter('footer.companyIntro')"
              >{{ t('footer.companyIntro') }}</NuxtLink
            >
            <NuxtLink
              :to="`/product`"
              class="text-[#333333] text-[20px] font-medium hover:text-gray-900"
              @click="trackEventFooter('nav.products')"
              >{{ t('nav.products') }}</NuxtLink
            >
            <a
              href="https://app.mokahr.com/social-recruitment/boseq/140968?locale=zh-CN"
              target="_blank"
              class="ttext-[#333333] text-[20px] font-medium hover:text-gray-900"
              @click="trackEventFooter('footer.socialRecruitment')"
              >{{ t('footer.socialRecruitment') }}</a
            >
          </div>

          <!-- 第二列 -->
          <div class="flex flex-col space-y-[55px]">
            <a
              href="https://kaiwu.qboson.com/"
              target="_blank"
              class="text-[#333333] text-[20px] font-medium hover:text-gray-900"
              @click="trackEventFooter('nav.developer')"
              >{{ t('nav.developer') }}</a
            >
            <a
              href="https://platform.qboson.com/"
              target="_blank"
              class="text-[#333333] text-[20px] font-medium hover:text-gray-900"
              @click="trackEventFooter('nav.cloud')"
              >{{ t('nav.cloud') }}</a
            >
            <a
              href="https://app.mokahr.com/campus-recruitment/boseq/140969?locale=zh-CN"
              target="_blank"
              class="text-[#333333] text-[20px] font-medium hover:text-gray-900"
              @click="trackEventFooter('footer.schoolRecruitment')"
              >{{ t('footer.schoolRecruitment') }}</a
            >
          </div>
          <!-- </div> -->

          <!-- 右侧：二维码和联系方式 -->
          <div class="flex-shrink-0">
            <div class="mb-4">
              <img
                src="@/assets/images/code.png"
                alt="二维码"
                class="w-[114px] h-[114px] bg-gray-300"
              />
            </div>
            <div class="text-sm text-gray-600 space-y-2">
              <div class="flex items-center">
                <img
                  src="@/assets/images/icons/phone.png"
                  alt="phone"
                  class="w-[14px] h-[14px] mr-2"
                />
                <span class="text-[#333333] font-normal text-[16px]">{{
                  t('footer.phone')
                }}</span>
              </div>
              <div class="flex items-center">
                <img
                  src="@/assets/images/icons/email.png"
                  alt="email"
                  class="w-[14px] h-[14px] mr-2"
                />
                <span class="text-[#333333] font-normal text-[16px]">{{
                  t('footer.email')
                }}</span>
              </div>
              <div class="flex items-start">
                <img
                  src="@/assets/images/icons/address.png"
                  alt="address"
                  class="w-[14px] h-[14px] mr-2"
                />
                <span class="text-[#333333] font-normal text-[16px]">{{
                  t('footer.address')
                }}</span>
              </div>
            </div>
          </div>
        </div>

        <!-- 底部版权信息 -->
        <div class="text-center text-sm text-gray-400 pt-6">
          <span>{{ t('footer.copyright') }} </span>
          <span>
            备案号:
            <a
              href="https://beian.miit.gov.cn/"
              target="_blank"
              class="hover:text-gray-500 transition-colors"
              >京ICP备2021019544号-1</a
            >
            <a
              href="https://beian.mps.gov.cn/#/query/webSearch?code=11010502045479"
              target="_blank"
              class="hover:text-gray-500 transition-colors ml-1"
              >京公网安备 11010502045479号</a
            >
          </span>
        </div>
      </div>

      <!-- 移动端布局 -->
      <div class="md:hidden">
        <!-- 标语 -->
        <div class="text-gray-800 font-bold text-[16px] mb-[24px]">
          {{ t('footer.slogan') }}
        </div>

        <!-- 导航链接（须用绝对路径或 NuxtLink，相对路径在 /product 下会变成 /product/about） -->
        <div class="flex justify-start gap-[24px] mb-[10px] text-gray-700">
          <NuxtLink
            :to="'/about'"
            class="text-[12px] hover:text-gray-900"
            @click="trackEventFooter('footer.companyIntro')"
          >
            {{ t('footer.companyIntro') }}
          </NuxtLink>
          <NuxtLink
            :to="'/product'"
            class="text-[12px] hover:text-gray-900"
            @click="trackEventFooter('nav.products')"
          >
            {{ t('nav.products') }}
          </NuxtLink>
          <a
            href="https://platform.qboson.com/"
            target="_blank"
            class="text-[12px] hover:text-gray-900"
            >{{ t('nav.cloud') }}</a
          >
        </div>
        <!-- 导航链接 -->
        <div class="flex justify-start gap-[24px] mb-[31px] text-gray-700">
          <a
            href="https://app.mokahr.com/social-recruitment/boseq/140968?locale=zh-CN"
            target="_blank"
            class="text-[12px] hover:text-gray-900"
            >{{ t('footer.socialRecruitment') }}</a
          >
          <a
            href="https://app.mokahr.com/campus-recruitment/boseq/140969?locale=zh-CN"
            target="_blank"
            class="text-[12px] hover:text-gray-900"
            >{{ t('footer.schoolRecruitment') }}</a
          >
          <a
            href="https://kaiwu.qboson.com/"
            target="_blank"
            class="text-[12px] hover:text-gray-900"
            >{{ t('nav.developer') }}</a
          >
        </div>

        <!-- 二维码和联系方式 -->
        <div class="flex items-start space-x-6 mb-8">
          <!-- 二维码 -->
          <div class="flex-shrink-0">
            <img
              src="@/assets/images/code.png"
              alt="二维码"
              class="w-[74px] h-[74px] bg-gray-300 border-[1px] border-black"
            />
          </div>

          <!-- 联系方式 -->
          <div class="text-xs text-gray-600">
            <div>
              <div class="text-gray-500 mb-1">
                {{ t('footer.contactPhone') }}：{{ t('footer.phone') }}
              </div>
            </div>
            <div>
              <div class="text-gray-500 mb-1">
                {{ t('footer.contactEmail') }}：{{ t('footer.email') }}
              </div>
            </div>
            <div>
              <div class="text-gray-500 mb-1">
                {{ t('footer.contactAddress') }}：{{ t('footer.address') }}
              </div>
            </div>
          </div>
        </div>

        <!-- 底部版权信息 -->
        <div class="text-[10px] text-gray-400">
          <div class="mb-2">
            {{ t('footer.copyright') }}
          </div>
          <div>
            备案号:
            <a
              href="https://beian.miit.gov.cn/"
              target="_blank"
              class="hover:text-gray-500 transition-colors"
              >京ICP备2021019544号-1</a
            >
            <a
              href="https://beian.mps.gov.cn/#/query/webSearch?code=11010502045479"
              target="_blank"
              class="hover:text-gray-500 transition-colors ml-1"
              >京公网安备 11010502045479号</a
            >
          </div>
        </div>
      </div>
    </div>
  </footer>
</template>
